module.exports = __webpack_public_path__ + "static/media/making-wishes-2.c6a0cd27.jpg";